
import { createSlice } from "@reduxjs/toolkit";
import {getInjury} from '../reduxApi/injuryReduxApi';

const injurySlice = createSlice({
    name: 'injury',
    initialState: {
        status: 'idel',
        injury: [],
    },
    reducers: {
        deleteinjuryAction: (state, action) => {
            action.payload.forEach((ROWID) => {
                const index = state.injury.findIndex((item) => item.ROWID === ROWID);
                if (index !== -1) {
                    state.injury.splice(index, 1);
                }
            });
        },
        updateinjuryAction: (state, action) => {
            console.log("action", action.payload.ROWID)
            const index = state.injury.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.injury.splice(index, 1, action.payload)
    
            }
        },
        addinjuryAction: (state, action) => {
            console.log("Adding injury:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.injury.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInjury.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getInjury.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing injury Data", action.payload)
                state.injury = action.payload.data.injuryResp
;
            })
    }
})
export const { deleteinjuryAction, updateinjuryAction, addinjuryAction } = injurySlice.actions
export default injurySlice.reducer